module.exports = __webpack_public_path__ + "static/media/the-wildstorm-vol3.ed7c290e.jpg";